/* eslint-env browser */

import * as React from 'react'
import PropTypes from 'prop-types'
import withTranslator from '../TranslatorProvider'

const axios = require('axios')
const classnames = require('classnames')

const ModalsHelper = require('../../../../client/clientjs/utils/modals')

class LikeButton extends React.Component {
  constructor() {
    super()
    this.onButtonClick = this.onButtonClick.bind(this)
    this.updateLikes = this.updateLikes.bind(this)
    this.state = {}
  }

  componentWillMount() {
    const { currentUserLike, likesNumber } = this.props
    this.setState({
      currentUserLike,
      likesNumber: likesNumber || 0,
    })
  }

  onButtonClick() {
    const { isLoggedIn, likeable, likeableId } = this.props
    const { currentUserLike } = this.state

    if (!isLoggedIn) {
      ModalsHelper.open('#modal-signup')
      return
    }
    this.setState({ loading: true })
    if (currentUserLike) {
      axios
        .delete(`/api/likes/${currentUserLike.id}`)
        .then(this.updateLikes)
        .then(() => this.setState({ loading: false }))
      return
    }
    axios
      .post('/api/likes/', {
        likeable,
        likeableId,
      })
      .then(this.updateLikes)
      .then(() => this.setState({ loading: false }))
  }

  updateLikes() {
    const { likeable, likeableId } = this.props

    return axios.get(`/api/likes/${likeable}/${likeableId}`).then(res => {
      const currentUserLikeId = res.headers['x-current-user-like-id']
      this.setState({
        currentUserLike: currentUserLikeId ? { id: currentUserLikeId } : undefined,
        likesNumber: res.headers['x-total-count'],
      })
    })
  }

  render() {
    const { size, translate } = this.props
    const { currentUserLike, loading, likesNumber } = this.state
    const tooltip = translate(currentUserLike ? 'likeButton.unlike' : 'likeButton.like')

    return (
      <button
        type="button"
        onClick={this.onButtonClick}
        className={classnames(
          'button is-small tooltip tooltip-top button-like',
          { 'liked is-call-to-action': currentUserLike },
          { 'is-default': !currentUserLike }
        )}
        data-tooltip={tooltip}
        style={{ height: 'auto' }}
        disabled={loading}
      >
        <i
          className={classnames({ fas: currentUserLike }, { far: !currentUserLike }, 'fa-thumbs-up fa-fw', {
            'fa-2x': size === 'medium',
          })}
        >
          &nbsp;
        </i>
        <b>{likesNumber}</b>
      </button>
    )
  }
}

LikeButton.propTypes = {
  likeable: PropTypes.string.isRequired,
  likeableId: PropTypes.string.isRequired,
  likesNumber: PropTypes.number.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  currentUserLike: PropTypes.object,
  translate: PropTypes.func.isRequired,
  size: PropTypes.string,
}

LikeButton.defaultProps = {
  currentUserLike: undefined,
  size: 'medium',
}

module.exports = withTranslator(LikeButton)
